import { storeSelector, usePolicyContext } from '@Policy/store';
import { raiActionDataSelector } from '@Policy/store/filters/riskAI';
import { PolicyModeEnum } from '@Policy/utils/constants';
import Actions from '../../../Components/Actions';
import isEqual from 'lodash/isEqual';

function PhishingSection() {
  const contextStore = usePolicyContext();
  const contextSelector = storeSelector(contextStore);
  const { phishingActionData, policyMode } = contextSelector((s) => {
    const actionData = raiActionDataSelector(s);
    return {
      phishingActionData: actionData.phishingActionData,
      policyMode: s.template.policyMode,
    };
  }, isEqual);

  return (
    <Actions
      actionData={phishingActionData}
      disabledAll={policyMode === PolicyModeEnum.DefaultMonitorPolicy}
    />
  );
}

export default PhishingSection;
